import { PropsWithChildren } from 'react';
import { Navigate } from 'react-router';
import { SkinFeatureKey, useSkinFeature } from '../config/skinRegistry/configs';

type Props = {
  feature: SkinFeatureKey;
  redirect: string;
};

const SkinFeatureGuard = ({ feature, redirect, children }: PropsWithChildren<Props>) => {
  const enabled = useSkinFeature(feature);

  if (!enabled) return <Navigate to={redirect} replace />;

  return <>{children}</>;
};

export default SkinFeatureGuard;
